import get from "lodash/get";

export default {
  fetchFiles({ commit, rootState }) {
    const productId = get(rootState, "setup.product_id");
    if (!productId) {
      commit("setFiles", []);
      return Promise.resolve([]);
    }

    commit("setFilesLoading", true);
    return window.axios
      .get(`/ebook-reader/products/${productId}/files`)
      .then(response => {
        const files = response.data.results || [];
        commit("setFiles", files);
        return files;
      })
      .catch(error => {
        // 404 means product has no ebook — treat as empty, not fatal
        if (error.response && error.response.status === 404) {
          commit("setFiles", []);
          return [];
        }
        return Promise.reject(error);
      })
      .finally(() => {
        commit("setFilesLoading", false);
      });
  },

  fetchFileMeta({ commit }, fileId) {
    commit("setMetaLoading", true);
    return window.axios
      .get(`/ebook-reader/files/${fileId}/meta`)
      .then(response => {
        commit("setCurrentFileMeta", response.data);
        return response.data;
      })
      .finally(() => {
        commit("setMetaLoading", false);
      });
  },

  fetchPageBlob(context, { fileId, pageNumber }) {
    return window.axios
      .get(`/ebook-reader/files/${fileId}/pages/${pageNumber}`, {
        responseType: "blob"
      })
      .then(response => {
        return URL.createObjectURL(response.data);
      });
  }
};
